var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('p',[_vm._v(" Copyright (©) 2025 北京尚亚科技有限公司版权所有 ")])])
}]

export { render, staticRenderFns }